"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
var e = require("./taggedTemplateLiteral-97b463ad.js"),
  t = require("styled-components"),
  n = require("polished/lib/helpers/rem"),
  r = require("./gradients-74ddcb08.js");
function a(e) {
  return e && "object" == _typeof(e) && "default" in e ? e : {
    "default": e
  };
}
var i,
  o,
  l,
  c,
  u,
  d,
  g = a(t),
  s = a(n),
  h = function h(e) {
    return parseInt(e, 16);
  },
  p = function p(e, t) {
    var n,
      r = e.r,
      a = e.g,
      i = e.b,
      o = e.a,
      l = (n = t, !isNaN(parseFloat(n)) && isFinite(n) ? t : o);
    return "rgba(".concat(r, ", ").concat(a, ", ").concat(i, ", ").concat(l, ")");
  },
  f = function f(e, t) {
    var n,
      r,
      a = function (e) {
        return "#" === e.charAt(0) ? e.slice(1) : e;
      }(e),
      i = function (e) {
        var t = e.r,
          n = e.g,
          r = e.b,
          a = e.a;
        return {
          r: h(t),
          g: h(n),
          b: h(r),
          a: +(h(a) / 255).toFixed(2)
        };
      }({
        r: (r = 3 === (n = a).length || 4 === n.length) ? "".concat(n.slice(0, 1)).concat(n.slice(0, 1)) : n.slice(0, 2),
        g: r ? "".concat(n.slice(1, 2)).concat(n.slice(1, 2)) : n.slice(2, 4),
        b: r ? "".concat(n.slice(2, 3)).concat(n.slice(2, 3)) : n.slice(4, 6),
        a: (r ? "".concat(n.slice(3, 4)).concat(n.slice(3, 4)) : n.slice(6, 8)) || "ff"
      });
    return p(i, t);
  },
  b = function b(e, t, n, a) {
    if ("lightTheme" === a) {
      if ("lightA" === e) return n.colors.background.lightTheme.lightA;
      if ("lightB" === e) return n.colors.background.lightTheme.lightB;
      if ("lightC" === e) return n.colors.background.lightTheme.lightC;
      if ("lightSky" === e) return n.colors.background.lightTheme.lightSky;
    }
    if ("darkTheme" === a) {
      if ("pcg" === t) return "\n        ".concat(r.gradients.pcgBlue, ";\n      ");
      if ("darkDefault" === e) return n.colors.background.darkTheme.darkDefault;
    }
    return n.colors.background.lightTheme.lightA;
  },
  m = function m(e, t) {
    return "darkTheme" === t ? e.colors.text.darkTheme["default"] : e.colors.text.lightTheme["default"];
  },
  k = function k(e, t, n) {
    var r = t,
      a = "blue" === e ? n.colors.background.lightTheme.texture.blue : n.colors.background.darkTheme.texture.sky;
    return "radial-gradient(".concat(r, " at ").concat("center", ", ").concat(a, " 10%, transparent 10%), transparent");
  },
  T = g["default"].section(i || (i = e._taggedTemplateLiteral(["\n  ", "\n"])), function (n) {
    var r = n.backgroundVariant,
      a = n.branding,
      i = n.disableBottomPadding,
      l = n.disableTopPadding,
      c = n.hasTexture,
      u = n.theme,
      d = n.themeType,
      g = u.mediumUp(),
      h = s["default"](48);
    i ? h = 0 : g && (h = s["default"](52));
    var p = s["default"](40);
    l ? p = 0 : g && (p = s["default"](52));
    var f = b(r, a, u, d);
    return t.css(o || (o = e._taggedTemplateLiteral(["\n      position: relative; /** for hasTexture */\n      max-width: unset;\n      padding-top: ", ";\n      && {\n        padding-bottom: ", ";\n      }\n      background: ", ";\n      color: ", ";\n      ", "\n    "])), p, h, f, m(u, d), c && "& >.nmx-container {\n          position: relative;\n          z-index: 1;\n        }");
  }),
  x = g["default"].div(l || (l = e._taggedTemplateLiteral(["\n  ", "\n"])), function (n) {
    var r = n.backgroundVariant,
      a = n.branding,
      i = n.textureGranuleColor,
      o = n.textureGranuleShape,
      l = n.theme,
      u = n.themeType,
      d = b(r, a, l, u),
      g = k(i, o, l);
    return t.css(c || (c = e._taggedTemplateLiteral(["\n      display: block;\n      position: absolute;\n      top: 0;\n      width: 100%;\n      height: 100%;\n      margin-left: -60%;\n      background: ", ";\n      background-size: ", ";\n\n      &::after {\n        content: '';\n        position: absolute;\n        display: block;\n        top: 0;\n        right: 0;\n        width: ", ";\n        height: 100%;\n        background: linear-gradient(\n          45deg,\n          ", " 40%,\n          ", " 50%\n        );\n      }\n    "])), g, "15px 15px", s["default"](500), f(d, 0), d);
  }),
  v = g["default"].div(u || (u = e._taggedTemplateLiteral(["\n  ", "\n"])), function (n) {
    var r = n.backgroundVariant,
      a = n.branding,
      i = n.textureGranuleColor,
      o = n.textureGranuleShape,
      l = n.theme,
      c = n.themeType,
      u = b(r, a, l, c),
      g = k(i, o, l);
    return t.css(d || (d = e._taggedTemplateLiteral(["\n      display: block;\n      position: absolute;\n      top: 0;\n      width: 100%;\n      height: 100%;\n      margin-left: 60%;\n      background: ", ";\n      background-size: ", ";\n\n      &::after {\n        content: '';\n        position: absolute;\n        display: block;\n        top: 0;\n        left: 0;\n        width: ", ";\n        height: 100%;\n        background: linear-gradient(\n          45deg,\n          ", " 50%,\n          ", " 60%\n        );\n      }\n    "])), g, "15px 15px", s["default"](500), u, f(u, 0));
  });
exports.BgTextureLeftContainerStyled = x, exports.BgTextureRightContainerStyled = v, exports.SectionContainerStyled = T, exports.getSectionBackgroundColor = b, exports.getSectionColor = m;